import { render, staticRenderFns } from "./permission-debug.vue?vue&type=template&id=0c530818&scoped=true&lang=pug&"
import script from "./permission-debug.vue?vue&type=script&lang=ts&"
export * from "./permission-debug.vue?vue&type=script&lang=ts&"
import style0 from "./permission-debug.vue?vue&type=style&index=0&id=0c530818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c530818",
  null
  
)

export default component.exports